import { useExperiment } from '..'
import { Asset, Experiment, ExperimentValue, PostCheckoutEligibility, whitelistedCaptureType } from '../../model'
import { useAssetEligible, useBrowserEligible, useConsumerEligible, useOrderEligible, usePersonalizationEnabled, usePostCheckoutFlow } from './helper'

interface PostCheckoutExperimentHook {
  enabled: boolean
  experiment: Experiment
  value: ExperimentValue
}

export const usePostCheckoutEligibility = (asset: Asset): PostCheckoutEligibility => {
  const isPersonalizationEnabled = usePersonalizationEnabled()
  const isBrowserEligible = useBrowserEligible()
  const isConsumerEligible = useConsumerEligible(asset.id)
  const isOrderEligible = useOrderEligible()
  const isAssetEligible = useAssetEligible(asset)
  const flow = usePostCheckoutFlow()

  if (!isPersonalizationEnabled) {
    return {
      result: false,
      browser: false,
      consumer: false,
      order: false,
      asset: false,
      merchant: false,
    }
  }

  const acceptableCaptureType = whitelistedCaptureType.includes(flow)

  const conditions = [isBrowserEligible, isConsumerEligible, isOrderEligible, isAssetEligible, acceptableCaptureType]
  const valueIsTrue = (value: boolean): boolean => value
  const result = conditions.every(valueIsTrue)

  return {
    result,
    browser: isBrowserEligible,
    consumer: isConsumerEligible,
    order: isOrderEligible,
    asset: isAssetEligible,
    merchant: acceptableCaptureType,
  }
}

export const usePostCheckoutExperiment = (): PostCheckoutExperimentHook => {
  const experiment = useExperiment('PostCheckoutPersonalization', false)
  const { active, control, value } = experiment
  const enabled = active && !control

  return { enabled, experiment, value }
}
